// extracted by mini-css-extract-plugin
export default {"goesOnSalePosition":"tU+-8"};